import React, { useState } from 'react';

import { Select, SelectItem } from 'carbon-components-react';

const CustomSubformSelectInput = props => {
  const [value, setValue] = useState(props.formData);

  const onChange = event => {
    const selected = event.currentTarget.selectedIndex;
    const enumValues = props.schema.enum;
    setValue(enumValues[selected]);
    props.onChange(enumValues[selected]);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 10,
        marginTop: 14,
        alignItems: 'flex-start'
      }}
    >
      <Select
        id={props.idSchema.$id}
        defaultValue={value}
        light
        invalidText='A valid value is required'
        labelText={props.schema.title}
        onChange={onChange}
        style={{ background: 'white', width: '100%', minWidth: '200px' }}
      >
        {props.schema.enum.map((option, i) => (
          <SelectItem
            key={`${props.idSchema.$id}-option-${i}`}
            hidden={i === 0}
            disabled={i === 0}
            value={option}
            text={props.schema.enumNames[i]}
          />
        ))}
      </Select>
    </div>
  );
};

export default CustomSubformSelectInput;
